<template>
  <div class="page-news">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah`"
          >招工招生</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/admission`"
          >招生平台</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ columnMeta.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content">
        <column-header2 :data="columnMeta"></column-header2>
        <ic-news :data="columnData" :type="columnMeta.type"></ic-news>
        <el-pagination
          v-if="columnData.length > pageSize"
          class="g-pagination"
          :current-page="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
          background
          @current-change="handleIndexChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import News from "_c/News";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      metaData: {
        SchoolRecruitmentPlan: {
          name: "招生计划",
          type: "calendar",
          tableId: "SchoolRecruitmentPlan",
          showBreadNav: false
        },
        SchoolAdmissionInfo: {
          name: "录取信息",
          type: "calendar",
          tableId: "SchoolAdmissionInfo",
          showBreadNav: true
        },
        SchoolEnrollmentBrochure: {
          name: "招生简章",
          tableId: "SchoolEnrollmentBrochure",
          type: "calendar"
        }
      },
      columnMeta: {},
      name: "",
      total: 0,
      pageSize: 9,
      pageIndex: 1,
      columnData: []
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [News.name]: News,
    [ColumnHeader.name]: ColumnHeader
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      let params = [
        {
          Key: "School",
          Value: this.collegeData.college.SchoolId,
          CompareType: "EqualTo"
        }
      ];
      var queryParams = {
        name: this.columnMeta.tableId,
        index: this.pageIndex,
        size: this.pageSize,
        params: params
      };
      getData(queryParams).then(res => {
        this.columnData = (res.Data || []).map(item => {
          item.link =
            this.$subsitePrefix +
            `/ah/admission/detail/${this.columnMeta.tableId}?id=${item.Id}`;
          return item;
        });
        this.total = res.TotalCount;
      });
    },
    init() {
      let loadingOptions = {
        target: this.$refs.mainContainer,
        fullscreen: false
      };
      let loadingInstance = Loading.service(loadingOptions);

      let name = this.$route.params.name;
      this.name = name;
      this.columnMeta = this.metaData[name];
      if (this.columnMeta) {
        this.loadData();
      }
      loadingInstance.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-news {
    padding: 5px 0 20px 0;
  }
  .news-content {
    padding-bottom: 40px;
    ::v-deep .comp-column-header {
      padding: 0;
    }
  }
}
</style>
